const ENV_STYLES: Record<
  string,
  { label: string; dot: string; badge: string }
> = {
  development: {
    label: 'DEVELOPMENT',
    dot: 'bg-blue-500',
    badge: 'bg-blue-600 text-white ring-2 ring-blue-300',
  },
  uat: {
    label: 'UAT',
    dot: 'bg-amber-400',
    badge: 'bg-amber-500 text-white ring-2 ring-amber-300',
  },
}

const envKey = (process.env.REACT_APP_ENV ?? '').toLowerCase().trim()
const envConfig = ENV_STYLES[envKey] ?? null

const EnvBadge = () => {
  if (!envConfig) return null

  return (
    <span
      className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-bold uppercase tracking-widest ${envConfig.badge}`}
    >
      <span className={`h-2 w-2 animate-pulse rounded-full ${envConfig.dot}`} />
      {envConfig.label}
    </span>
  )
}

export default EnvBadge
